const DataHeader = {
    name: "YUBER SANTIAGO",
    lastName: "PAEZ VILLALBA",
    ocupation: "ANALISTA Y DESARROLLADOR DE SOFTWARE",
}

export default DataHeader;